<script>

    import ModalContainer from '../$components/modal.container.svelte'

    import PricingComponent from './component.pricing.svelte'
    import PricingsComponent from './component.pricings.svelte'
    import PricingUpdateComponent from './component.update.svelte'
    import PricingUploadComponent from './component.upload.svelte'
    import PricingCreateComponent from './component.create.svelte'

    import TitleHero from '../$components/title.hero.svelte'
    import View from '../$layouts/view.layout.svelte'

</script>

<View>
    <div>
        <TitleHero title="Precios" subtitle="Consulta y gestión de precios" />
        <PricingsComponent />
    </div>
</View>

<ModalContainer id="pricing_modal" title="Pricing" >
    <PricingComponent />
</ModalContainer>

<ModalContainer id="pricing_create_modal" title="Registrar pricing" >
    <PricingCreateComponent />
</ModalContainer>

<ModalContainer id="pricing_update_modal" title="Actualizar pricing" >
    <PricingUpdateComponent />
</ModalContainer>

<ModalContainer id="pricing_upload_modal" title="Cargar pricing" >
    <PricingUploadComponent />
</ModalContainer>